/* eslint-disable */
export default {
  dialer: 'Clavier de numérotation',
  allCalls: 'Tous les appels',
} as const;

// @key: @#@"dialer"@#@ @source: @#@"Dial Pad"@#@
// @key: @#@"allCalls"@#@ @source: @#@"All Calls"@#@
